import React, { useState } from "react";
import { FiUpload } from "react-icons/fi"; // Import the upload icon
import "react-quill/dist/quill.snow.css"; // Import the styles for React Quill
import ReactQuill from "react-quill";
//import { addCouncilMember,fetchCouncilMembers } from "../redux/actions/aboutUsActions";
import { useDispatch } from "react-redux";

export default function AddMembersForm({ title, addMemberAction, fetchMembersAction}) {

  const dispatch = useDispatch();
  const [message, setMessage] = useState(""); // State to hold the message content

  const [formData, setFormData] = useState({
      name: "",
      designation: "",
      biography: "",
      file: null, // Store only the actual file here
      imagePreview: null,
    });

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };

    const isValidImageType = (file) => {
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'];
        return allowedTypes.includes(file.type);
    };
  
    const handleImageUpload = (e) => {
      const file = e.target.files[0];

      if (file) {
        if (!isValidImageType(file)) {
            alert("Invalid image type.  Only JPG, JPEG PNG, and WEBP images are allowed.");
            e.target.value = ''; // Clear the selected file from the input
            return;
        }
        // Set the file as the full File object for preview, but only send the name in FormData
        const reader = new FileReader();
        reader.onloadend = () => {
          setFormData({ ...formData, file, imagePreview: reader.result });
        };
        reader.readAsDataURL(file);
      }
    };
    const handleQuillChange = (content) => {
      setFormData({ ...formData, biography: content });
    };

  const handleSubmit = (e) => {
      e.preventDefault();
  
       // Sanitize or extract plain text
      // const sanitizedMessage = DOMPurify.sanitize(formData.message);
  
      // // You can also extract plain text using a temporary DOM element
      // const plainText = sanitizedMessage.replace(/<[^>]*>/g, "");

      if (!formData.name || !formData.designation || !formData.biography || !formData.file) {
        alert("All fields are required!");
        return;
      }
    
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("designation", formData.designation);
      formDataToSend.append("biography",  formData.biography);
      if (formData.file) {
        formDataToSend.append("file", formData.file);
      }
    
      dispatch(
        addMemberAction(formDataToSend, () => {
          alert("Member added successfully!");
           // Reset the form data to clear the form
      setFormData({
        name: "",
        designation: "",
        biography: "",
        file: null,
        imagePreview: null,
      });
      window.location.reload(true); 
          dispatch(fetchMembersAction());
        })
      );
    };

  const modules = {
    toolbar: [
   
      [{ header: [1, 2, 3, false] }], // Heading styles
      [{ font: [] }],   // Font selection
      ["bold", "italic", "underline"], // Font styles
      [{ align: [] }], // Alignment options
      ["clean"], // Clear formatting
    ],
  };

  const formats = [
    "font",
    "header",
    "bold",
    "italic",
    "underline",
    "align",
  ];

  return (
    <div className="p-4 mb-6 bg-white rounded-lg shadow-md">
      <h2 className="mb-4 text-xl font-semibold text-gray-700">{title}</h2>
      <form onSubmit={handleSubmit}>
        {/* Row 1: Position, Name, Designation */}
        <div className="grid grid-cols-2 gap-4 mb-4">
         
          

          {/* Name Input */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="name">
              Name
            </label>
            <input
              id="name"
              name="name"
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
              value={formData.name}
              onChange={handleInputChange}
            />
          </div>

          {/* Designation Input */}
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="designation">
              Designation
            </label>
            <input
              id="designation"
              name="designation"
              type="text"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
              value={formData.designation}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {/* Row 2: Image Drop Field & Message Input */}
        <div className="grid grid-cols-3 gap-4 mb-4">
                  {/* Image Drop Field */}
                  <div className="flex flex-col items-center justify-center w-full h-[225px] p-5 border border-gray-300 border-dashed rounded-md relative">
                    <input
                      type="file"
                      name="file"
                      accept=".jpg, .png,.webp, .jpeg"
                      className="absolute inset-0 opacity-0 cursor-pointer"
                      onChange={handleImageUpload}
                    />
                    {formData.imagePreview ? (
                      <div className="w-full h-full">
                        <img
                          src={formData.imagePreview}
                          alt="Uploaded Preview"
                          className="object-contain w-full h-full rounded-md"
                        />
                      </div>
                    ) : (
                      <>
                        <FiUpload className="w-10 h-10 p-2 mb-3 text-gray-400 bg-gray-100 border-none rounded-md" />
                        <p className="text-black">Drag and drop image here</p>
                        <p className="text-sm text-center text-gray-400">
                        {/* Any size of image, will automatically adjust to the frame  */}
                        Image size should 300 px x 250 px (width x height)
                        </p>
                        <button
                          type="button"
                          className="px-4 py-2 mt-2 text-[#92288C] font-semibold bg-[#92288C] bg-opacity-10 rounded-md"
                          onClick={() => document.querySelector("input[name='file']").click()}
                        >
                          Browse Image
                        </button>
                      </>
                    )}
                  </div>
        
                  {/* Message Input (React Quill) */}
                  <div className="col-span-2 h-[200px]">
                    <label className="block mb-1 text-sm font-medium text-gray-600" htmlFor="biography">
                    Biography
                    </label>
                    <div className="h-full overflow-hidden border border-gray-300 rounded-md focus-within:border-gray-400">
                      <ReactQuill
                        id="biography"
                        value={formData.biography}
                        onChange={handleQuillChange}
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        className="h-[300px]"
                        placeholder="Enter your message here..."
                      />
                    </div>
                  </div>
                </div>


        {/* Submit Button */}
        <div className="flex justify-end">
          <button
            type="submit"
            className="px-6 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
          >
            Add
          </button>
        </div>
      </form>
    </div>
  );
}